import { Loader2, CheckCircle } from 'lucide-react';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  showSuccess?: boolean;
}

export function LoadingOverlay({ isVisible, message = "Processing...", showSuccess = false }: LoadingOverlayProps) {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl p-8 shadow-2xl max-w-md w-full mx-4 transform transition-all duration-300">
        <div className="text-center">
          {/* Loading Icon */}
          <div className="relative mb-6">
            {showSuccess ? (
              <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center">
                <CheckCircle className="w-8 h-8 text-green-600" />
              </div>
            ) : (
              <div className="w-16 h-16 mx-auto bg-blue-100 rounded-full flex items-center justify-center">
                <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
              </div>
            )}
          </div>

          {/* Loading Message */}
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            {showSuccess ? "Success!" : "Processing"}
          </h3>
          <p className="text-gray-600 mb-6">
            {message}
          </p>

          {/* Progress Bar */}
          {!showSuccess && (
            <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full animate-pulse"></div>
            </div>
          )}

          {/* Additional Info */}
          <p className="text-sm text-gray-500">
            {showSuccess ? "Moving to next step..." : "Please wait while we process your information"}
          </p>
        </div>
      </div>
    </div>
  );
}
